export const businessCardVariant = {
  initial: { opacity: 0 },
  enter: {
    opacity: 1,
    transition: { duration: 0.3, easeIn: [0.25, 0.1, 0.25, 1] },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      easeIn: [0.25, 0.1, 0.25, 1],
    },
  },
};

export const subtitleVariant = {
  enter: {
    y: 0,
  },
  exit: {
    y: '-100%',
  },
  initial: {
    y: '100%',
  },
};
